export default __webpack_public_path__ + "static/media/content1-background.c688c369.png";